// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EhzzIu0q {\n  background: var(--color-card-bg);\n  border: 1px solid var(--color-card-border);\n  border-radius: var(--radius-sm);\n  padding: 14px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.PRDpggS0 {\n  margin: 0;\n  font-family: var(--font-primary);\n  font-size: 13px;\n  line-height: 1.55;\n  color: var(--color-card-title);\n  white-space: pre-wrap;\n}\n\n.jZ3BB20o {\n  background: var(--color-rewrite-highlight);\n  border-left: 3px solid var(--color-rewrite-highlight-border);\n  padding: 8px 10px;\n  border-radius: 4px;\n  margin-left: -2px;\n}\n\n._s_ouLEX {\n  color: var(--color-card-title);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": "EhzzIu0q",
	"paragraph": "PRDpggS0",
	"added": "jZ3BB20o",
	"original": "_s_ouLEX"
};
export default ___CSS_LOADER_EXPORT___;
